import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Table, FormControl } from 'react-bootstrap';
import cx from 'classnames';
import { connect } from 'react-redux';
import { flowRight as compose } from 'lodash';
import PropTypes from 'prop-types';

import CustomPagination from '../../CustomPagination';
import Loader from '../../../components/Common/Loader';
import CurrencyConverter from '../../CurrencyConverter';
import Link from '../../Link/Link';

import debounce from '../../../helpers/debounce';
import messages from '../../../locale/messages';
import { capitalizeFirstLetter } from '../../../helpers/capitalizeFirst';
import { demoRestrictionEncode } from '../../../actions/demoRestriction';
import showToaster from '../../../helpers/toastrMessgaes/showToaster';
import { censorWord, decode } from '../../../helpers/queryEncryption';

import { ExportCsvIcon } from '../../Common/Assets/SVGIcon/CommonSvgIcon';
import bt from '../../../components/commonStyle.css';
import s from './BookingList.css';

export class CompletedBookingList extends Component {
	static propTypes = {
		completedTrips: PropTypes.object,
	}

	constructor(props) {
		super(props)
		this.state = {
			currentPage: 1,
			isRestrict: false
		}
	}

	async componentDidMount() {
		const { demoRestrictionEncode } = this.props;
		const isRestrict = await demoRestrictionEncode({});
		this.setState({ isRestrict });
	}

	handleKeywordSearch = debounce((searchList) => {
		const { completedTrips: { refetch } } = this.props
		let variables = {
			currentPage: 1,
			searchList
		}
		this.setState(variables)
		refetch(variables)
	}, 250);

	paginationData = (currentPage) => {
		const { completedTrips: { refetch } } = this.props;
		let variables = { currentPage };
		this.setState({ currentPage });
		refetch(variables);
	}

	restrictExport = () => {
		showToaster({ messageId: 'disableDemo', toasterType: 'warning' })
	};


	render() {
		const { completedTrips, completedTrips: { loading } } = this.props;
		const { formatMessage } = this.props.intl;
		const { currentPage, searchList, isRestrict } = this.state;

		return (
			<div>
				<div className={s.exportDisplay}>
					<div className={s.searchGroupContainer}>
						<div className={cx(s.searchInput, 'searchInputRTL')}>
							<FormControl type='text' placeholder={formatMessage(messages.searchOnly)} onChange={(e) => this.handleKeywordSearch(e.target && e.target.value)} className={bt.formControlInput} />
						</div>
					</div>
					<div className={cx(s.exportTextSection)}>
						{
							completedTrips?.getCompletedBookings?.results && completedTrips?.getCompletedBookings?.results?.length > 0 && (isRestrict ? <a
								href={`#`} className={cx(s.exportTextContainer)} onClick={() => this.restrictExport()}>
								<span className={cx(s.vtrMiddle, s.exportText, 'exportTextRTL')}><FormattedMessage {...messages.exportDataIntoCSV} /></span>
								<span className={cx(s.vtrTextBottom)}>
									<ExportCsvIcon />
								</span>
							</a> : <a
								href={`/export-admin-data?type=jobs&status[0]=completed&keyword=${searchList ? searchList : ''}`}
								className={cx(s.exportTextContainer)}>
								<span className={cx(s.vtrMiddle, s.exportText, 'exportTextRTL')}><FormattedMessage {...messages.exportDataIntoCSV} /></span>
								<span className={cx(s.vtrTextBottom)}>
									<ExportCsvIcon />
								</span>
							</a>)
						}
					</div>
				</div>

				{
					loading && <div>
						<Loader type="circle" />
					</div>
				}

				{!loading &&
					<div className='tableOuterContainer'>
						<Table className="tableContainer">
							<thead>
								<tr>
									<th scope="col"><FormattedMessage {...messages.id} /></th>
									<th scope="col"><FormattedMessage {...messages.userName} /></th>
									<th scope="col"><FormattedMessage {...messages.partnerName} /></th>
									<th scope="col"><FormattedMessage {...messages.category} /></th>
									<th scope="col"><FormattedMessage {...messages.bookingStatus} /></th>
									<th scope="col"><FormattedMessage {...messages.totalFare} /></th>
									<th scope="col"><FormattedMessage {...messages.details} /></th>
									<th scope="col"><FormattedMessage {...messages.chatLabel} /></th>
								</tr>
							</thead>
							<tbody>
								{
									completedTrips?.getCompletedBookings?.results && completedTrips?.getCompletedBookings?.results?.length > 0 && completedTrips?.getCompletedBookings?.results?.map((item, index) => {
										return (
											<tr key={index}>
												<td data-label={formatMessage(messages.id)}>{item?.id}</td>
												<td data-label={formatMessage(messages.userName)}>{item && item?.userDetails && capitalizeFirstLetter(isRestrict ? censorWord(decode(item?.userDetails.encryptFirstName)) : decode(item?.userDetails.encryptFirstName))}</td>
												<td data-label={formatMessage(messages.partnerName)}>{item && item?.partnerDetails && capitalizeFirstLetter(isRestrict ? censorWord(decode(item?.partnerDetails.encryptFirstName)): decode(item?.partnerDetails.encryptFirstName))}</td>
												<td data-label={formatMessage(messages.category)}>{item && item?.categoryDetails && item?.categoryDetails.name}</td>
												<td data-label={formatMessage(messages.bookingStatus)}>{item?.status && messages[item.status] ? formatMessage(messages[item.status]) : item.status}</td>
												<td data-label={formatMessage(messages.totalFare)}><CurrencyConverter from={item?.currency} amount={item?.userPayableFare} /></td>
												<td data-label={formatMessage(messages.details)}>
													<div>
														<Link to={'/siteadmin/completed-jobs/view/' + item?.id} className="actionLinkText"><FormattedMessage {...messages.view} /></Link>
													</div>
												</td>
												<td data-label={formatMessage(messages.chatLabel)}>
													<div>
														{item?.messageData && item?.messageData?.threadItemsCount > 0 ? <Link to={'/siteadmin/completed-jobs/chat-message/' + item?.id} className="actionLinkText"><FormattedMessage {...messages.view} /></Link> : "-"}
													</div>
												</td>
											</tr>
										)
									})
								}
								{
									!loading && completedTrips?.getCompletedBookings?.results && completedTrips?.getCompletedBookings?.results?.length == 0 && (
										<tr>
											<td colspan="12" className={'tableNoRecordCel'}><FormattedMessage {...messages.noResult} /></td>
										</tr>
									)
								}
							</tbody>
						</Table>
					</div>
				}
				{
					completedTrips?.getCompletedBookings?.results && completedTrips?.getCompletedBookings?.results?.length > 0
					&& <div className={cx(bt.space5, bt.spaceTop5)}>
						<CustomPagination
							total={completedTrips?.getCompletedBookings.count}
							currentPage={currentPage}
							defaultCurrent={1}
							defaultPageSize={10}
							change={this.paginationData}
							paginationLabel={formatMessage(messages.manageCompletedBooking)}
						/>
					</div>
				}
			</div>
		)
	}
}

const mapState = (state) => ({});

const mapDispatch = {
	demoRestrictionEncode
};

export default compose(injectIntl,
	withStyles(bt, s),
	connect(mapState, mapDispatch),
)(CompletedBookingList);

